/** The outreach pill colours (Figma 505:49931). Grey and red have no Figma pill: they keep the stopped and error looks. */
export const PILL_GREEN = 'bg-(--pill-green-bg) text-(--pill-green-fg)';
export const PILL_BLUE = 'bg-(--pill-blue-bg) text-(--pill-blue-fg)';
export const PILL_INDIGO = 'bg-(--pill-indigo-bg) text-(--pill-indigo-fg)';
export const PILL_AMBER = 'bg-(--pill-amber-bg) text-(--pill-amber-fg)';
// Stone/200, not Stone/100: a selected inbox row is Stone/100 (bg-muted) and would swallow the pill.
export const PILL_GREY = 'bg-(--stone-200) text-(--foreground-secondary-default)';
export const PILL_RED = 'bg-rose-100 text-rose-700';

export type PillColor = 'green' | 'blue' | 'indigo' | 'amber' | 'grey' | 'red';

export const PILL_COLORS: Record<PillColor, string> = {
  green: PILL_GREEN,
  blue: PILL_BLUE,
  indigo: PILL_INDIGO,
  amber: PILL_AMBER,
  grey: PILL_GREY,
  red: PILL_RED,
};
